import { render, staticRenderFns } from "./wish.vue?vue&type=template&id=e02c6f84&scoped=true&"
import script from "./wish.vue?vue&type=script&lang=js&"
export * from "./wish.vue?vue&type=script&lang=js&"
import style0 from "./wish.vue?vue&type=style&index=0&id=e02c6f84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e02c6f84",
  null
  
)

export default component.exports